// // src/pages/CodonOccupancy/components/SingleGroupManager.jsx
// import React, { useState, useMemo, useCallback } from "react";
// import {
//   Card,
//   CardHeader,
//   CardBody,
//   Row,
//   Col,
//   Button,
//   Badge,
//   Alert,
//   Input,
// } from "reactstrap";

// const SingleGroupManager = ({
//   files, // ✅ All files (for finding assigned file details)
//   filteredFiles, // ✅ Filtered files (for available files display)
//   selectedFiles,
//   onToggleFile,
//   onToggleAll,
//   groupFiles,
//   onAddFiles,
//   onRemoveFiles,
//   onClearGroup,
// }) => {
//   const [draggedIds, setDraggedIds] = useState([]);
//   const [isDragOver, setIsDragOver] = useState(false);

//   // Available files (not in group) - use filteredFiles for current filter
//   const availableFiles = useMemo(
//     () => filteredFiles.filter((f) => !groupFiles.includes(f.file_id)),
//     [filteredFiles, files, groupFiles]
//   );

//   // Drag and drop handlers
//   const handleDragStart = useCallback(
//     (e, fileId) => {
//       const multi = selectedFiles.includes(fileId)
//         ? selectedFiles.filter((id) =>
//             availableFiles.some((f) => f.file_id === id)
//           )
//         : [fileId];
//       setDraggedIds(multi);
//       e.dataTransfer.effectAllowed = "move";
//     },
//     [selectedFiles, availableFiles]
//   );

//   const handleDragOver = useCallback((e) => {
//     e.preventDefault();
//     e.dataTransfer.dropEffect = "move";
//     setIsDragOver(true);
//   }, []);

//   const handleDragLeave = useCallback((e) => {
//     if (!e.currentTarget.contains(e.relatedTarget)) {
//       setIsDragOver(false);
//     }
//   }, []);

//   const handleDrop = useCallback(
//     (e) => {
//       e.preventDefault();
//       onAddFiles(draggedIds);
//       setDraggedIds([]);
//       setIsDragOver(false);
//     },
//     [draggedIds, onAddFiles]
//   );

//   // File selection handlers
//   const toggleSelect = useCallback((id) => onToggleFile(id), [onToggleFile]);

//   const allAvailableIds = useMemo(
//     () => availableFiles.map((f) => f.file_id),
//     [availableFiles]
//   );

//   const allSelected = useMemo(
//     () =>
//       allAvailableIds.every((id) => selectedFiles.includes(id)) &&
//       allAvailableIds.length > 0,
//     [allAvailableIds, selectedFiles]
//   );

//   // Mouse handlers for better UX
//   const handleFileMouseEnter = useCallback((e, isSelected) => {
//     if (!isSelected) {
//       e.currentTarget.style.backgroundColor = "#f0f9ff";
//       e.currentTarget.style.borderColor = "#2F9E37";
//       e.currentTarget.style.transform = "translateY(-1px)";
//     }
//   }, []);

//   const handleFileMouseLeave = useCallback((e, isSelected) => {
//     if (!isSelected) {
//       e.currentTarget.style.backgroundColor = "white";
//       e.currentTarget.style.borderColor = "#e5e7eb";
//       e.currentTarget.style.transform = "translateY(0)";
//     }
//   }, []);

//   return (
//     <Card className="shadow-sm">
//       <CardHeader className="border-bottom">
//         <div className="d-flex justify-content-between align-items-center">
//           <div>
//             <h5
//               className="mb-0"
//               style={{ color: "#1a6d51", fontSize: "18px", fontWeight: "600" }}
//             >
//               <i className="ri-folder-transfer-line me-2"></i>
//               Files
//             </h5>
//           </div>
//           <div className="d-flex gap-2">
//             {availableFiles.length > 0 && (
//               <div
//                 className="text-center "
//                 style={{
//                   background:
//                     "linear-gradient(135deg, #1a6d51 0%, #29a161ff 100%)",
//                   color: "white",
//                   borderRadius: "6px",
//                   padding: "4px 12px",
//                   fontSize: "11px",
//                   display: "inline-block",
//                 }}
//               >
//                 <i
//                   className="ri-cursor-line me-1"
//                   style={{ fontSize: "12px" }}
//                 ></i>
//                 Click files to select/deselect them. Use{" "}
//                 <kbd
//                   style={{
//                     fontSize: "9px",
//                     padding: "1px 3px",
//                     backgroundColor: "rgba(255,255,255,0.2)",
//                     border: "none",
//                   }}
//                 >
//                   Shift
//                 </kbd>
//                 +Click for range selection. Drag files to groups.
//               </div>
//             )}{" "}
//             <Button
//               size="sm"
//               onClick={() => onToggleAll(allAvailableIds, !allSelected)}
//               style={{
//                 backgroundColor: "#28a745",
//                 borderColor: "#28a745",
//                 color: "white",
//                 fontSize: "12px",
//                 padding: "6px 12px",
//                 borderRadius: "6px",
//               }}
//             >
//               <i className=" ri-arrow-right-up-fill me-2"></i>
//               {allSelected ? "Deselect All" : "Select All"}
//             </Button>
//             {groupFiles.length > 0 && (
//               <Button
//                 size="sm"
//                 onClick={onClearGroup}
//                 style={{
//                   backgroundColor: "transparent",
//                   border: "1px solid #dc3545",
//                   color: "#dc3545",
//                   fontSize: "12px",
//                   padding: "6px 12px",
//                   borderRadius: "6px",
//                 }}
//               >
//                 <i className="ri-delete-bin-line me-1"></i>
//                 Clear Group
//               </Button>
//             )}
//           </div>
//         </div>
//       </CardHeader>

//       <CardBody className="p-4">
//         <Row>
//           {/* Available Files */}
//           <Col lg={6}>
//             <div className="mb-3">
//               {/* Instructions for range selection */}

//               <div
//                 style={{
//                   // height: `${Math.min(
//                   //   Math.max(availableFiles.length * 40 + 16, 120),
//                   //   320
//                   // )}px`,
//                   minHeight: "300px",
//                   maxHeight: "300px",
//                   overflowY: "auto",
//                   border: "1px solid #e5e7eb",
//                   borderRadius: "6px",
//                   padding: "8px",
//                   backgroundColor: "#fafafa",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns:
//                       "repeat(auto-fill, minmax(180px, 1fr))",
//                     gap: "6px",
//                   }}
//                 >
//                   {availableFiles.map((file, index) => {
//                     const isSelected = selectedFiles.includes(file.file_id);

//                     return (
//                       <div
//                         key={file.file_id}
//                         draggable
//                         onDragStart={(e) => handleDragStart(e, file.file_id)}
//                         onClick={() => toggleSelect(file.file_id)}
//                         onMouseEnter={(e) =>
//                           handleFileMouseEnter(e, isSelected)
//                         }
//                         onMouseLeave={(e) =>
//                           handleFileMouseLeave(e, isSelected)
//                         }
//                         style={{
//                           padding: "6px",
//                           border: isSelected
//                             ? "1px solid #2F9E37"
//                             : "1px solid #e5e7eb",
//                           borderRadius: "4px",
//                           backgroundColor: isSelected ? "#f0fdf4" : "white",
//                           cursor: "pointer",
//                           fontSize: "12px",
//                           transition: "all 0.2s ease",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "4px",
//                           userSelect: "none",
//                         }}
//                       >
//                         <Input
//                           type="checkbox"
//                           checked={isSelected}
//                           readOnly
//                           style={{
//                             pointerEvents: "none",
//                             margin: 0,
//                             width: "14px",
//                             height: "14px",
//                           }}
//                         />
//                         <span
//                           style={{
//                             fontSize: "11px",
//                             lineHeight: "1.2",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                             flex: 1,
//                             color: isSelected ? "#2F9E37" : "#374151",
//                             fontWeight: isSelected ? "500" : "400",
//                           }}
//                           title={file.file_name}
//                         >
//                           {file.file_name}
//                         </span>
//                       </div>
//                     );
//                   })}
//                 </div>

//                 {availableFiles.length === 0 && (
//                   <div className="text-center text-muted py-4">
//                     <i className="ri-file-forbid-line fs-1 mb-2 d-block"></i>
//                     <p className="mb-0">
//                       All files have been added to the analysis group
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </Col>

//           <Col lg={6}>
//             <div className="mb-3">
//               <Card
//                 className="h-100"
//                 style={{
//                   minHeight: "300px",
//                   maxHeight: "300px",
//                   border: isDragOver
//                     ? "2px dashed #28a745"
//                     : "1px solid #e9ecef",
//                   backgroundColor: isDragOver ? "#f0fdf4" : "#f8f9fa",
//                   transition: "all 0.3s ease",
//                 }}
//                 onDragOver={handleDragOver}
//                 onDragLeave={handleDragLeave}
//                 onDrop={handleDrop}
//               >
//                 <CardBody className="d-flex flex-column p-3">
//                   {groupFiles.length === 0 ? (
//                     <div
//                       className="d-flex flex-column align-items-center justify-content-center text-center flex-grow-1"
//                       style={{ color: isDragOver ? "#28a745" : "#6c757d" }}
//                     >
//                       <i
//                         className="ri-upload-cloud-2-line mb-3"
//                         style={{ fontSize: "48px", opacity: 0.7 }}
//                       ></i>
//                       <div className="fw-semibold mb-2">
//                         {isDragOver ? "Drop files here" : "Drag files here"}
//                       </div>
//                       <small style={{ opacity: 0.8 }}>
//                         {selectedFiles.length > 0
//                           ? `${selectedFiles.length} files selected`
//                           : "Select files from the left panel to drag"}
//                       </small>
//                     </div>
//                   ) : (
//                     <div
//                       style={{
//                         overflowY: "auto",
//                         flexGrow: 1,
//                         maxHeight: "280px",
//                       }}
//                     >
//                       {groupFiles.map((id) => {
//                         const file = files.find((f) => f.file_id === id);
//                         return (
//                           <div
//                             key={id}
//                             className="d-flex justify-content-between align-items-center mb-2 p-2 rounded-2 bg-white border"
//                             style={{ fontSize: "12px" }}
//                           >
//                             <div className="d-flex align-items-center flex-grow-1">
//                               <i className="ri-file-3-line me-2 text-muted"></i>
//                               <span
//                                 className="fw-medium"
//                                 style={{
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                   whiteSpace: "nowrap",
//                                 }}
//                                 title={file?.file_name || `File ${id}`}
//                               >
//                                 {file?.file_name || `File ${id}`}{" "}
//                                 {/* ✅ Now finds correct name */}
//                               </span>
//                               {/* ✅ Added file type badge for better identification */}
//                               {file?.file_type && (
//                                 <Badge
//                                   color="info"
//                                   className="text-white ms-2"
//                                   style={{ fontSize: "8px" }}
//                                 >
//                                   {file.file_type}
//                                 </Badge>
//                               )}
//                             </div>
//                             <Button
//                               size="sm"
//                               color="link"
//                               className="text-danger p-0 ms-2"
//                               onClick={() => onRemoveFiles([id])}
//                               style={{
//                                 fontSize: "12px",
//                                 minWidth: "auto",
//                                 lineHeight: 1,
//                               }}
//                               title="Remove file"
//                             >
//                               <i className="ri-close-line"></i>
//                             </Button>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </CardBody>
//               </Card>
//             </div>
//           </Col>
//         </Row>
//       </CardBody>
//     </Card>
//   );
// };

// export default SingleGroupManager;

// src/pages/CodonOccupancy/components/SingleGroupManager.jsx
import React, { useState, useMemo, useCallback } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Badge,
  Alert,
  Input,
} from "reactstrap";

// Reusable File Item Component
const FileItem = React.memo(
  ({ file, fileId, isDragging, onDragStart, onDragEnd, onRemove }) => (
    <div
      key={fileId}
      draggable={true}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      style={{
        padding: "8px 12px",
        backgroundColor: isDragging
          ? "rgba(255,255,255,0.5)"
          : "rgba(255,255,255,0.8)",
        borderRadius: "6px",
        fontSize: "11px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        border: "1px solid rgba(255,255,255,0.5)",
        cursor: "grab",
        transition: "all 0.2s ease",
        opacity: isDragging ? 0.5 : 1,
        transform: isDragging ? "scale(0.95)" : "scale(1)",
        marginBottom: "4px",
      }}
      onMouseEnter={(e) => {
        if (!isDragging) {
          e.currentTarget.style.cursor = "grabbing";
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.1)";
        }
      }}
      onMouseLeave={(e) => {
        if (!isDragging) {
          e.currentTarget.style.cursor = "grab";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }
      }}
    >
      <div className="d-flex align-items-center flex-grow-1">
        <i className="ri-file-3-line me-2 text-muted"></i>
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "#374151",
            fontWeight: "500",
            flex: 1,
            marginRight: "8px",
          }}
          title={file?.file_name || `File ${fileId}`}
        >
          {file?.file_name || `File ${fileId}`}
        </span>
        {file?.file_type && (
          <Badge
            style={{
              fontSize: "8px",
              backgroundColor: "#6c757d",
              padding: "2px 4px",
              marginRight: "8px",
            }}
          >
            {file.file_type}
          </Badge>
        )}
      </div>
      <Button
        size="sm"
        onClick={(e) => {
          e.stopPropagation();
          onRemove([fileId]);
        }}
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "#dc3545",
          padding: "2px 4px",
          fontSize: "10px",
          minWidth: "20px",
          height: "20px",
        }}
      >
        <i className="ri-close-line"></i>
      </Button>
    </div>
  )
);

// Reusable Group Card Component
const GroupCard = React.memo(
  ({
    groupFiles,
    files,
    isDragOver,
    selectedFiles,
    onDragOver,
    onDragLeave,
    onDrop,
    onRemoveFiles,
  }) => {
    const renderFileItem = useCallback(
      (id) => {
        const file = files.find((f) => f.file_id === id);
        return (
          <FileItem
            key={id}
            file={file}
            fileId={id}
            isDragging={false}
            onDragStart={() => {}}
            onDragEnd={() => {}}
            onRemove={onRemoveFiles}
          />
        );
      },
      [files, onRemoveFiles]
    );

    return (
      <Card
        style={{
          backgroundColor: "#E8F5E8", // EIRNA green background
          border: isDragOver ? `2px dashed #1a6d51` : `1px solid #1a6d51`,
          borderRadius: "8px",
          minHeight: "300px", // Fixed height to match other components
          transition: "all 0.2s ease",
          transform: isDragOver ? "scale(1.02)" : "scale(1)",
          boxShadow: isDragOver
            ? `0 4px 12px rgba(0,0,0,0.15), 0 0 0 4px #1a6d5120`
            : "none",
        }}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <CardBody style={{ padding: "20px" }}>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  backgroundColor: "#1a6d51",
                  marginRight: "8px",
                }}
              />
              <span
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#1a6d51",
                }}
              >
                Analysis Group
              </span>
            </div>
          </div>

          {/* Files or Drop Zone */}
          {groupFiles.length === 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "200px",
                border: "2px dashed #ccc",
                borderRadius: "8px",
                backgroundColor: "rgba(255,255,255,0.5)",
                color: isDragOver ? "#1a6d51" : "#999",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              <i
                className="ri-upload-cloud-2-line"
                style={{
                  fontSize: "24px",
                  marginBottom: "8px",
                }}
              />
              <div className="fw-semibold mb-2">
                {isDragOver ? "Drop files here" : "Drag files here"}
              </div>
              <div style={{ fontSize: "10px", marginTop: "4px" }}>
                {selectedFiles.length > 0
                  ? `${selectedFiles.length} files selected`
                  : "Select files from the left to drag"}
              </div>
            </div>
          ) : (
            <div>
              <Badge
                style={{
                  backgroundColor: "#1a6d51",
                  color: "white",
                  fontSize: "10px",
                  marginBottom: "8px",
                }}
              >
                <i className="ri-file-line me-1"></i>
                {groupFiles.length} files
              </Badge>
              <div
                style={{
                  height: "180px", // Fixed height for file list
                  minHeight: "180px",
                  overflowY: "auto",
                  paddingRight: "4px",
                }}
              >
                {groupFiles.map((id) => renderFileItem(id))}
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    );
  }
);

const SingleGroupManager = ({
  files,
  filteredFiles,
  selectedFiles,
  onToggleFile,
  onToggleAll,
  groupFiles,
  onAddFiles,
  onRemoveFiles,
  onClearGroup,
}) => {
  const [draggedIds, setDraggedIds] = useState([]);
  const [isDragOver, setIsDragOver] = useState(false);

  // Available files (not in group) - use filteredFiles for current filter
  const availableFiles = useMemo(
    () => filteredFiles.filter((f) => !groupFiles.includes(f.file_id)),
    [filteredFiles, groupFiles]
  );

  // Mouse handlers for better UX
  const handleFileMouseEnter = useCallback((e, isSelected) => {
    if (!isSelected) {
      e.currentTarget.style.backgroundColor = "#f9fafb";
      e.currentTarget.style.borderColor = "#d1d5db";
    }
  }, []);

  const handleFileMouseLeave = useCallback((e, isSelected) => {
    if (!isSelected) {
      e.currentTarget.style.backgroundColor = "white";
      e.currentTarget.style.borderColor = "#e5e7eb";
    }
  }, []);

  // Drag and drop handlers
  const handleDragStart = useCallback(
    (e, fileId) => {
      const multi = selectedFiles.includes(fileId)
        ? selectedFiles.filter((id) =>
            availableFiles.some((f) => f.file_id === id)
          )
        : [fileId];
      setDraggedIds(multi);
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", fileId);
      e.dataTransfer.setData("application/json", JSON.stringify(multi));
      document.body.style.cursor = "grabbing";
    },
    [selectedFiles, availableFiles]
  );

  const handleDragEnd = useCallback(() => {
    setDraggedIds([]);
    setIsDragOver(false);
    document.body.style.cursor = "default";
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setIsDragOver(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false);
    }
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      let filesToAdd = [];
      try {
        const jsonData = e.dataTransfer.getData("application/json");
        if (jsonData) {
          filesToAdd = JSON.parse(jsonData);
        } else {
          const singleFile = e.dataTransfer.getData("text/plain");
          if (singleFile) {
            filesToAdd = [singleFile];
          }
        }
      } catch (error) {
        if (draggedIds.length > 0) {
          filesToAdd = draggedIds;
        }
      }

      if (filesToAdd.length > 0) {
        onAddFiles(filesToAdd);
      }

      setDraggedIds([]);
      setIsDragOver(false);
    },
    [draggedIds, onAddFiles]
  );

  // File selection handlers
  const toggleSelect = useCallback((id) => onToggleFile(id), [onToggleFile]);

  const allAvailableIds = useMemo(
    () => availableFiles.map((f) => f.file_id),
    [availableFiles]
  );

  const allSelected = useMemo(
    () =>
      allAvailableIds.every((id) => selectedFiles.includes(id)) &&
      allAvailableIds.length > 0,
    [allAvailableIds, selectedFiles]
  );

  return (
    <Card
      className="mb-4"
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "1px",
        height: "100%",
        minHeight: "400px",
        maxHeight: "450px",
      }}
    >
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <div>
            <h5
              className="mb-0"
              style={{ color: "#1a6d51", fontSize: "18px", fontWeight: "600" }}
            >
              <i className="ri-folder-transfer-line me-2"></i>
              Files
            </h5>
          </div>

          <div className="d-flex gap-2">
            {groupFiles.length > 0 && (
              <Button
                size="sm"
                onClick={onClearGroup}
                style={{
                  backgroundColor: "transparent",
                  border: "1px solid #dc3545",
                  color: "#dc3545",
                  fontSize: "12px",
                  padding: "6px 12px",
                  borderRadius: "6px",
                }}
              >
                <i className="ri-delete-bin-line me-1"></i>
                Clear Group
              </Button>
            )}
            <Button
              size="sm"
              onClick={() => onToggleAll(allAvailableIds, !allSelected)}
              disabled={availableFiles.length === 0}
              style={{
                backgroundColor: "#28a745",
                borderColor: "#28a745",
                color: "white",
                fontSize: "12px",
                padding: "6px 12px",
                borderRadius: "6px",
              }}
            >
              <i className="ri-arrow-right-up-fill me-2"></i>
              {allSelected ? "Deselect All" : "Select All"}
            </Button>
          </div>
        </div>
      </CardHeader>

      <CardBody style={{ padding: "20px" }}>
        {/* Available Files Section */}
        <div className="mb-4">
          {availableFiles.length > 0 && (
            <div
              className="text-center mb-2"
              style={{
                background:
                  "linear-gradient(135deg, #1a6d51 0%, #29a161ff 100%)",
                color: "white",
                borderRadius: "6px",
                padding: "4px 12px",
                fontSize: "11px",
                display: "inline-block",
              }}
            >
              <i
                className="ri-cursor-line me-1"
                style={{ fontSize: "12px" }}
              ></i>
              Click files to select/deselect them. Use{" "}
              <kbd
                style={{
                  fontSize: "9px",
                  padding: "1px 3px",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  border: "none",
                }}
              >
                Shift
              </kbd>
              +Click for range selection. Drag files to group.
            </div>
          )}

          <Row>
            {/* Available Files Column */}
            <Col lg={6}>
              <div
                style={{
                  minHeight: "300px",
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  padding: "8px",
                  backgroundColor: "#fafafa",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(180px, 1fr))",
                    gap: "6px",
                  }}
                >
                  {availableFiles.map((file, index) => {
                    const isSelected = selectedFiles.includes(file.file_id);

                    return (
                      <div
                        key={file.file_id}
                        draggable
                        onDragStart={(e) => handleDragStart(e, file.file_id)}
                        onDragEnd={handleDragEnd}
                        onClick={() => toggleSelect(file.file_id)}
                        onMouseEnter={(e) =>
                          handleFileMouseEnter(e, isSelected)
                        }
                        onMouseLeave={(e) =>
                          handleFileMouseLeave(e, isSelected)
                        }
                        style={{
                          padding: "6px",
                          border: isSelected
                            ? "1px solid #2F9E37"
                            : "1px solid #e5e7eb",
                          borderRadius: "4px",
                          backgroundColor: isSelected ? "#f0fdf4" : "white",
                          cursor: "pointer",
                          fontSize: "12px",
                          transition: "all 0.2s ease",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          userSelect: "none",
                        }}
                      >
                        <Input
                          type="checkbox"
                          checked={isSelected}
                          readOnly
                          style={{
                            pointerEvents: "none",
                            margin: 0,
                            width: "14px",
                            height: "14px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "11px",
                            lineHeight: "1.2",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            flex: 1,
                            color: isSelected ? "#2F9E37" : "#374151",
                            fontWeight: isSelected ? "500" : "400",
                          }}
                          title={file.file_name}
                        >
                          {file.file_name}
                        </span>
                      </div>
                    );
                  })}
                </div>

                {availableFiles.length === 0 && (
                  <div className="text-center text-muted py-4">
                    <i className="ri-file-forbid-line fs-1 mb-2 d-block"></i>
                    <p className="mb-0">
                      All files have been added to the analysis group
                    </p>
                  </div>
                )}
              </div>
            </Col>

            {/* Group Column */}
            <Col lg={6}>
              <GroupCard
                groupFiles={groupFiles}
                files={files}
                isDragOver={isDragOver}
                selectedFiles={selectedFiles}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onRemoveFiles={onRemoveFiles}
              />
            </Col>
          </Row>
        </div>
      </CardBody>
    </Card>
  );
};

export default SingleGroupManager;
